import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../api/adminClientApi';
import { LoginPageView } from '../_layouts/LoginPageView';
import { AmorgAdminPageProvider } from '../_contexts/AmorgAdminPageContext';

export function AmorgAdminLogin():JSX.Element
{

    return (
        <AmorgAdminPageProvider>
            <Login />
        </AmorgAdminPageProvider>
    );
}


function Login():JSX.Element
{
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const navigate = useNavigate();

    async function handleLogin(e?: React.FormEvent) {
        if (e) e.preventDefault();
        const result = await login(email, password);
        if(result === true)
            navigate('/amorgy');
    }

    return (
        <LoginPageView
            cardHeader="AMORGY"
            cardBackgroundColor="chocolate"
            onSubmit={handleLogin}
            email={email}
            onEmailChange={setEmail}
            password={password}
            onPasswordChange={setPassword}
        />
    );
}